class AttachedCommunication {
    public IndividualMessageId: string;
    public PatientContactId: string;
    public CreatedDate: Date;
    public RecallId: string;
    public Subject: string;
    public StatusId: string;
    public IsMessageRead: boolean;
    public IsRecallCompleted: boolean;
}

export { AttachedCommunication };
